const titles = ['Ms', 'Miss', 'Mrs', 'Mr', 'Dr', 'Prof'];
const countries = {
  'AU': {
    name: 'Australia',
    states: ['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA']
  }
};
const industries = [
  'Accommodation and Food Services',
  'Administrative and Support Services',
  'Agriculture, Forestry and Fishing',
  'Arts and Recreation Services',
  'Construction',
  'Education and Training',
  'Electricity, Gas, Water and Waste Services',
  'Financial and Insurance Services',
  'FMCG (Fast Moving Consumable Goods)',
  'Health Care and Social Assistance',
  'Information Media and Telecommuncations',
  'Manufacturing (non FMCG)',
  'Mining',
  'Professional, Scientific and Technical Services',
  'Public Administration and Safety',
  'Rental, Hiring and Real Estate Services',
  'Retail Trade',
  'Transport, Postal and Warehousing',
  'Wholesale Trade',
  'Other'
];

const supportUrl = 'https://smart39.zendesk.com/hc/en-us';

const userRoles = [
  {
    value: 'Traveller',
    selected: true,
    title: 'Traveller',
    description: 'Restricted to making and monitoring their own itineraries'
  },
  {
    value: 'TravelArranger',
    selected: false,
    title: 'Booker',
    description: 'Book and manage travel for your team'
  },
  {
    value: 'DebtorAdmin',
    selected: false,
    title: 'Admin',
    description: 'Complete unrestricted access'
  }
];

const roles = {
  DebtorAdmin: 'Admin',
  TravelArranger: 'Booker',
  Traveller: 'Traveller',
  DebtorAdministrator: 'Admin'
};

const errorMessageConfig = {
  title: `Whoops, something went wrong`,
  message: 'Please try again...',
  warningLevel: 'warning',
  submitButtonText: 'OK'
};

export default {
  titles,
  countries,
  industries,
  supportUrl,
  userRoles,
  roles,
  errorMessageConfig
};


// WEBPACK FOOTER //
// ./src/config/sctConfig.js